import * as React from 'react';

export default (props:any) => (
    <svg
        width={32}
        height={32}
        viewBox="24 24 96 96"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        {...props}
    >
        <g transform={'scale(1.5)'}>
            <path
                d="M37.1,45.3h21.8v-8.2c0-3-1.1-5.6-3.2-7.7c-2.1-2.1-4.7-3.2-7.7-3.2s-5.6,1.1-7.7,3.2 c-2.1,2.1-3.2,4.7-3.2,7.7V45.3z M72.5,49.4v24.5c0,1.1-0.4,2.1-1.2,2.9c-0.8,0.8-1.8,1.2-2.9,1.2H27.5c-1.1,0-2.1-0.4-2.9-1.2 c-0.8-0.8-1.2-1.8-1.2-2.9V49.4c0-1.1,0.4-2.1,1.2-2.9c0.8-0.8,1.8-1.2,2.9-1.2h1.4v-8.2c0-5.2,1.9-9.7,5.6-13.5S42.8,18,48,18 s9.7,1.9,13.5,5.6c3.8,3.8,5.6,8.2,5.6,13.5v8.2h1.4c1.1,0,2.1,0.4,2.9,1.2C72.1,47.3,72.5,48.2,72.5,49.4z" />
        </g>
    </svg>
);
